import React, { useEffect, useState, useRef, useCallback } from "react";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import Banner from "../../assets/components/banner";
import SmallBanner from "../../assets/components/smallBanner";
import BannerSlider from "../../assets/containers/bannerSlider";
import NoResultAlter from "../../assets/components/UI/NoResultAlter";
import appApi from "../../assets/utils/AppApi";
import Loading from "../../assets/containers/loadingDialog";
import BlogFilters from "../blog/BlogFilters";
import Classes from "./Styles/Style.module.css";

const ArchivePage = () => {
  const getInitialFilter = () => {
    if (typeof window === "undefined") return "";

    const searchParams = new URLSearchParams(window.location.search);
    const filterFromUrl = searchParams.get("filter");

    return filterFromUrl?.trim() ? filterFromUrl.trim() : "";
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totPages, setTotPages] = useState(1);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState(getInitialFilter);
  const observer = useRef();

  const getArchiveBanners = async (page, filter) => {
    setLoading(true);
    try {
      await appApi
        .get(
          `/banner/getbyposition/Archived?page=${page}&limit=10&searchString=${filter}`
        )
        .then(({ data }) => {
          setTotPages(data.totalPages);
          setData((prevItems) => [...prevItems, ...data.docs]);
          setLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    setData([]);
    setPage(1);
  }, [filter]);

  useEffect(() => {
    getArchiveBanners(page, filter);
  }, [page, filter]);

  const lastElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && page < totPages) {
          setPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, page, totPages]
  );

  return (
    <AnimatedPageContainer>
      <div className="container mb-4 mt-2">
        <BlogFilters
          selected={filter}
          handleClick={(f) => setFilter(f)}
          archive
        />
        {loading && page === 1 ? (
          <Loading
            className={"w-100 d-flex justify-content-center my-5 py-5"}
          />
        ) : data.length !== 0 ? (
          <div className={`w-100 row mx-0 px-0 justify-content-between ${Classes.fixedBannersList}`}>
            {data.map((banner, index) => {
              const isLastElement = index === data.length - 1;

              if (banner.type === "Video") {
                return (
                  <div
                    className="col-12"
                    ref={isLastElement ? lastElementRef : null}
                    key={index}
                  >
                    <BannerSlider banners={[{ ...banner }]} />
                  </div>
                );
              }
              if (!banner.src && banner.srcList.length !== 0) {
                const bannersCopy = banner.srcList.map((item) => {
                  if (item.type === "Image") {
                    return { ...banner, src: item.src, type: "Image" };
                  } else {
                    return {
                      ...banner,
                      src: item.src,
                      videoCover: item.videoCover,
                      type: "Video",
                    };
                  }
                });
                return (
                  <div
                    className="col-12"
                    ref={isLastElement ? lastElementRef : null}
                    key={index}
                  >
                    <BannerSlider banners={bannersCopy} />
                  </div>
                );
              }

              if (banner.rowCount > 1) {
                return (
                  <div
                    className={`${
                      banner.rowCount === 2
                        ? "col-6"
                        : banner.rowCount === 3
                        ? "col-4"
                        : "col-3"
                    }  mx-0 px-1`}
                    ref={isLastElement ? lastElementRef : null}
                    key={index}
                  >
                    <SmallBanner
                      src={banner.src}
                      href={banner.link}
                      title={banner.title}
                      showText={banner.titleVisible}
                      glow={banner.highlight}
                    />
                  </div>
                );
              } else {
                return (
                  <div
                    className="col-md-12 mx-0 px-0 px-md-2"
                    ref={isLastElement ? lastElementRef : null}
                    key={index}
                  >
                    <Banner
                      src={banner.src}
                      href={banner.link}
                      title={banner.title}
                      showText={banner.titleVisible}
                      date={banner.timer}
                      dateLabel={banner.timerLabel}
                      // glow={banner.highlight}
                      glow={false} //We don't want to show glow effect on archived banners, as they are not active anymore
                    />
                  </div>
                );
              }
            })}
            {loading && (
              <Loading
                className={"w-100 d-flex justify-content-center my-5 py-5"}
              />
            )}
          </div>
        ) : (
          <NoResultAlter className={"w-100  py-5 my-5"} />
        )}
      </div>
    </AnimatedPageContainer>
  );
};

export default ArchivePage;
